// components
import ComponentsRender from '@/components/ComponentsRender';

// constants
import { COMPONENTS } from '@/components/components';

const Columns = ({ split, column1, column2, reverse, columnsAlign: align }) => {
  const reverseClass = reverse ? 'flex-col-reverse xl:flex-row' : '';
  const alignClass =
    align === 'end'
      ? 'items-end'
      : align === 'center'
        ? 'items-center'
        : align === 'stretch'
          ? 'items-stretch'
          : 'items-start';

  return (
    <div className="mx-auto my-8 w-[90vw] text-center xl:my-20 xl:w-(--container-width)">
      <div className={`flex flex-wrap justify-between gap-x-30 gap-y-6 ${alignClass} ${reverseClass}`.trim()}>
        <div className="flex-1">
          {(column1 || []).map((component) => (
            <ComponentsRender key={`${component.id}_${component.__typename}`} type={COMPONENTS} component={component} />
          ))}
        </div>
        <div className="flex-1">
          {(column2 || []).map((component) => (
            <ComponentsRender key={`${component.id}_${component.__typename}`} type={COMPONENTS} component={component} />
          ))}
        </div>
      </div>
    </div>
  );
};
export default Columns;
